<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M27 2H5a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 3v3H17V4h10a1 1 0 0 1 1 1M5 4h10v18H4V5a1 1 0 0 1 1-1M4 27v-3h11v4H5a1 1 0 0 1-1-1m23 1H17V10h11v17a1 1 0 0 1-1 1"/></svg>
</template>
